<template>
  <div :class="classObject">
    <select :name="name" :id="id" :disabled="disabled" @change="updateValue">
      <option
        v-for="(option, i) in options"
        :key="i"
        :value="option.value"
        :selected="option.value === selected"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'
import { SelectOption } from '@/types/InputItems'

export default defineComponent({
  name: 'InputSelectbox',

  props: {
    id: String,
    name: String,
    options: {
      type: Array as PropType<SelectOption[]>,
      required: true
    },
    selected: String,
    addClass: Object,
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },

  setup(props, { emit }) {
    const classObject = computed(() => {
      return {
        selectbox: true,
        disabled: props.disabled,
        error: props.error,
        ...props.addClass
      }
    })

    const updateValue = (e: any) => {
      emit('selection-change', e.target.value)
    }

    return {
      classObject,
      updateValue
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.selectbox {
  position: relative;
  flex-grow: 1;
  margin-left: 7px;
  margin-right: 7px;
  height: 50px;
  background-color: var.$color-white;
  border: 1px solid var.$color-border-gray;
  border-radius: 10px;
  box-shadow: 0 6px 9px rgba(0, 0, 0, 0.08);
  font-size: 1.4rem;
  color: inherit;

  &::before {
    position: absolute;
    top: 0;
    right: 0;
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-right: 2px solid var.$color-main;
    border-bottom: 2px solid var.$color-main;
    transform: rotate(45deg) translate(1px, 27px);
    transition: border-color 0.1s;
  }

  &.disabled {
    background-color: #d3d3d3;
  }

  &.disabled::before {
    border-color: #999;
  }

  &.error {
    border-color: var.$color-red;
  }

  select {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 10px 40px 10px 10px;
  }
}
</style>
